module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/grid/flex-column/flex-column.component.scss
// module id = ./src/app/features/grid/flex-column/flex-column.component.scss
// module chunks = main